<template>
  <div v-loading.body="loading">
    <div class="c_page-title">
      <div>扫码达人</div>
      <el-button
        class="icon-fresh"
        size="mini"
        icon="el-icon-refresh"
        @click="fetchData(true)"
        >刷新</el-button
      >
    </div>
    <el-row class="filter">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>查询搜索</div>
          <el-button
            type="text"
            style="margin-left: auto"
            :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            @click="toggleFilter"
            >{{ filterFold ? "展开筛选" : "收起筛选" }}</el-button
          >
        </div>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px">
              <el-form :inline="true" :model="form" class="demo-form-inline">
                <el-form-item label="">
                  <el-input
                    v-model="form.admin_name"
                    placeholder="扫码账号"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item label="扫码时间：">
                  <el-date-picker
                    v-model="form.create_time"
                    type="datetimerange"
                    :default-time="['06:00:00', '06:00:00']"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item>
                  <el-date-picker
                    v-model="form.commit_time"
                    type="datetimerange"
                    :default-time="['06:00:00', '06:00:00']"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="search">查询</el-button>
                </el-form-item>

                <div style="float: right">
                  <el-button type="success" @click="outputAll(1)">
                    按勾选导出</el-button
                  >
                  <el-button type="success" @click="outputAll(2)">
                    按查询导出</el-button
                  >
                </div>
              </el-form>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>
    <el-row>
      <el-col style="border: 1px solid #ddd">
        <div style="margin-bottom: 0">
          <el-table
            v-if="resData"
            ref="multipleTable"
            v-loading="tableLoading"
            :data="resData.data"
            height="600"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="changeSelection"
          >
            <el-table-column align="center" type="selection"></el-table-column>
            <el-table-column
              align="center"
              prop="admin_name"
              label="账号"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="create_time"
              label="扫码时间"
            ></el-table-column>
            <el-table-column align="center" prop="dbids" label="扫码详情">
              <template slot-scope="scope">
                <el-popover placement="top-start" trigger="hover">
                  <div
                    style="
                      word-wrap: break-word;
                      word-break: break-all;
                      overflow: hidden;
                      max-width: 700px;
                    "
                  >
                    {{ scope.row.dbids }}
                  </div>
                  <el-button slot="reference">{{ scope.row.dbids }}</el-button>
                </el-popover>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="commit_time"
              label="提交时间"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="scan_dbids_status"
              label="状态"
            ></el-table-column>
            <el-table-column label="操作" show-overflow-tooltip align="center">
              <template slot-scope="scope">
                <el-button
                  style="background: #85ce61"
                  type="success"
                  size="small"
                  @click="output(scope.row.id)"
                  >导出</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div v-if="resData" style="text-align: right; padding: 25px">
          <el-pagination
            :current-page.sync="form.page"
            background
            layout="total, prev, pager, next, jumper, sizes"
            :total="resData.total"
            :page-sizes="[20, 50, 100, 200]"
            @current-change="handleCurrentChange"
            @size-change="
              (val) => {
                form.page_size = val;
                handleCurrentChange();
              }
            "
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import apiBaseURL from "@/utils/baseUrl.js";

export default {
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchData();
    });
  },
  data() {
    return {
      logData: [],
      logVisible: false,
      resData: {},
      form: {
        page: 1,
      },
      loading: false,
      tableLoading: false,
      url: "/erp/DaBiaoRecord/ScanDbidsList",
      curPage: 1,
      filterFold: false,
      selection: [], // 已勾选的行
    };
  },
  computed: {
    filteredForm() {
      for (const key in this.form) {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      return this.form;
    },
  },
  methods: {
    // 表格勾选
    changeSelection(rows) {
      this.selection = [];
      rows.forEach((v) => {
        this.selection.push(v.id);
      });
    },

    output($id) {
      this.form.is_excel = 1;
      this.form.id = $id;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.form.is_excel = 0;
        if (res.data.code != 200) {
          this.$message.error(res.data.msg);
        } else if (res.data.code != 200) {
          this.$message.error(res.data.msg);
        } else {
          window.open(apiBaseURL + res.data.data.file);
        }
      });
    },

    // 多条导出
    // @parma excel_type:int {1:按勾选导出, 2:按查询导出}
    outputAll(excel_type) {
      const param = { excel_type };
      if (excel_type == 1) {
        if (this.selection.length == 0) {
          return this.$message.error("请先勾选数据");
        }
        param.ids = this.selection;
        param.is_excel = 1;
      } else {
        this.form.is_excel = 1;
        Object.assign(param, this.filteredForm);
      }
      this.$http
        .post(this.url, param)
        .then((rs) => {
          if (rs.data.code != 200) return this.$message.error(rs.data.msg);
          window.open(apiBaseURL + rs.data.data.file);
        })
        .finally((_) => {
          this.form.is_excel = 0;
        });
    },

    fetchData(showLoading) {
      this.loading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          return this.$message.error(res.data.msg);
        }
        this.resData = res.data.data;
        console.log(this.resData);
      });
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    handleSelectionChange(val) {
      const multipleSelection = [];
      for (const key in val) {
        multipleSelection[key] = {
          id: val[key].id,
        };
      }
      this.form.multipleSelection = JSON.stringify(multipleSelection);
    },
    // 切换页码
    handleCurrentChange(val) {
      this.form.page = val;
      this.fetchData();
    },
    search() {
      this.form.page = 1;
      this.loading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
}

.column {
  text-align: center;
  border: 1px solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/ScanDbidsList.vue